import styled from "styled-components";

export const BitsSingleStyled = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  border:1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  & > .bit__price {
    background-color: #f4f4f5;
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
    padding: 5px;
    border-radius: 8px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const ConflictIcon = styled.img`
  margin-left: 10px;
`;
